import moment from "moment";
import React, { Fragment } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postDnataForm } from "../../redux/actions/dnataActions";

const AboutForm = ({ appData, postDnataFormFunc }) => {
  const {
    firstName = "",
    lastName = "",
    emailAddress = "",
    dateOfBirth = moment(),
    nationalInsuranceNo = "",
    address: { addressLine1, town, postcode, county },
    mobileTelephone = "",
  } = {
    address: { addressLine1: "", town: "", postcode: "", county: "" },
    ...appData,
  }; // in case that candidate has no address

  let initialData = {
    firstName,
    lastName,
    emailAddress,
    dateOfBirth: moment(dateOfBirth).format("DD/MM/YYYY"),
    nationalInsuranceNo,
    addressLine1,
    postTown: town,
    postCode: postcode,
    county,
    mobileTelephone,
  };

  const validateDDMMYYYY = (value) => {
    if (!value) return true;
    const date = moment(value, "DD/MM/YYYY", true);
    return date.isValid();
  };

  if (appData.dnataOnboarding && appData.dnataOnboarding.about) {
    initialData = {
      ...initialData,
      ...appData.dnataOnboarding.about,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const initialState = {
    blurbBeginning: {
      htmlObj: (
        <div>
          Thank you for your interest in applying for a role with dnata Catering
          UK. Your application will be treated in the strictest of confidence in
          line with the European Union General Data Protection Regulation 2018
          (GDPR). The questions enclosed within this application form are
          mandatory as to what may be a contractual requirement of the role that
          you are applying for. We will use the answers within your application
          form to inform our recruitment and selection purposes only.
        </div>
      ),
    },
    whatRole: {
      title: "What role are you applying for?",
      value: getVal("whatRole"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "General Assistant", value: "General Assistant" },
        { label: "Warehouse Bond", value: "Warehouse Bond" },
      ],
      mandatory: true,
    },
    location: {
      title: "What is the location of this role?",
      value: getVal("location"),
      type: "select",
      selectOptions: [
        { label: "None", value: "" },
        { label: "Birmingham Airport", value: "Birmingham Airport" },
        { label: "Edinburgh Airport", value: "Edinburgh Airport" },
        { label: "Gatwick Airport", value: "Gatwick Airport" },
        { label: "Glasgow Airport", value: "Glasgow Airport" },
        { label: "Heathrow Airport", value: "Heathrow Airport" },
        { label: "Luton Airport", value: "Luton Airport" },
        { label: "Manchester Airport", value: "Manchester Airport" },
        { label: "Stansted Airport", value: "Stansted Airport" },
      ],
      mandatory: true,
    },
    whereHear: {
      title: "Where did you hear about this role?",
      value: getVal("whereHear"),
      mandatory: true,
    },
    blurbSection1: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Section 1 - About You"} />
        </div>
      ),
    },
    firstName: {
      title: "First Name:",
      value: getVal("firstName"),
      mandatory: true,
    },
    middleName: {
      title: "Middle Name:",
      value: getVal("middleName"),
    },
    lastName: {
      title: "Surname:",
      value: getVal("lastName"),
      mandatory: true,
    },
    prevName: {
      title: "Previous Name:",
      value: getVal("prevName"),
    },
    addressLine1: {
      title: "Address Line 1:",
      value: getVal("addressLine1"),
      mandatory: true,
    },
    postTown: {
      title: "Town:",
      value: getVal("postTown"),
      mandatory: true,
    },
    county: {
      title: "County:",
      value: getVal("county"),
      mandatory: true,
    },
    postCode: {
      title: "Postcode:",
      value: getVal("postCode"),
      mandatory: true,
    },
    emailAddress: {
      title: "Email Address",
      value: getVal("emailAddress"),
      mandatory: true,
    },
    mobileTelephone: {
      title: "Contact Number:",
      value: getVal("mobileTelephone"),
      mandatory: true,
    },
    dateOfBirth: {
      title: "Date of birth (dd/mm/yyyy):",
      value: getVal("dateOfBirth"),
      mandatory: true,
      validate: validateDDMMYYYY,
    },
    nationalInsuranceNo: {
      title: "National Insurance Number:",
      value: getVal("nationalInsuranceNo"),
      mandatory: true,
    },
    blurbSection2: {
      htmlObj: (
        <Fragment>
          <div>
            <HorizontalLine text={"Section 2 - Shift Availability"} />
          </div>
          At this stage of the application we are looking for you to advise on
          your current availability to work. For information on the shift
          patterns/hours of work for the position you are applying for please
          refer to the Job role advertisement.
        </Fragment>
      ),
    },
    Group1: {
      title:
        "Are you happy to commit to working evenings and weekends as part of a shift rota?",
      type: "checkbox",
      value: getVal("Group1"),
      mandatory: true,
    },
    Group2: {
      title: "Are you available to work full time (40 hours per week)?",
      type: "checkbox",
      value: getVal("Group2"),
      mandatory: true,
    },
    blurbDriversLicence: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Drivers licence"} />
        </div>
      ),
    },
    Group3: {
      title: "Do you hold a full and current drivers licence?",
      type: "checkbox",
      value: getVal("Group3"),
      mandatory: true,
    },
    Group9: {
      title: "Do you suffer from colour blindness?",
      type: "checkbox",
      value: getVal("Group9"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  // Converts the string AB123456C into
  // { 'nationalInsuranceNo1 : 'A',
  //    'nationalInsuranceNo2: 'B',
  //  ...
  //    'nationalInsuranceNo9: C }
  const convertNIToObj = (NI = "") =>
    NI.split("")
      .slice(0, 9) // NI number are only 9 characters long
      .reduce(
        (acc, v, i) => ({ ...acc, [`nationalInsuranceNo${i + 1}`]: v }), // Compute the key and assign value
        {} // Init with empty object, otherwise first element is wrong
      );

  const handleSubmit = () => {
    const individualNIs = convertNIToObj(fields.nationalInsuranceNo.value);
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postDnataFormFunc("about", {
      ...fieldValuesPayload,
      ...individualNIs,
    });
    history.push("/profile/edit/dnata-onboarding");
  };

  return (
    <FormCreator
      formTitle={"About You"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/dnata-onboarding")}
      onboardingBranch={"dnata"}
    />
  );
};
AboutForm.propTypes = {
  appData: any,
  postDnataFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postDnataFormFunc: postDnataForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(AboutForm);
